import { Box, IconButton, List, Typography } from "@mui/material";
import React from "react";
import { useTreeModifyContext } from "./TreeDataContext";
import AddIcon from "@mui/icons-material/Add";
import { ClickableAreasData } from "./ClickableAreasData";
import { ClickableAreaCard } from "./ClickableAreaCard";

interface ClickableAreasProps {
  clickableAreas: ClickableAreasData;
}

export function ClickableAreasArray(props: ClickableAreasProps) {
  const { saveChangesAtPath } = useTreeModifyContext();

  return (
    <Box key={"clickable-areas-array"}>
      <Box className="horizontal-flex">
        <Typography variant="subtitle1">Areas: </Typography>
        <IconButton
          color="primary"
          aria-label="add"
          onClick={() => {
            const newAreaName = "new-area";
            let newAreaNameIndex = 1;
            const newArea = { left: 0, top: 0, width: 100, height: 100 };
            while (Object.keys(props.clickableAreas).includes(newAreaName + newAreaNameIndex)) {
              newAreaNameIndex += newAreaNameIndex;
            }
            saveChangesAtPath(newArea, [newAreaName + newAreaNameIndex]);
          }}
        >
          <AddIcon />
        </IconButton>
      </Box>
      <List className="card-list-container">
        {Object.keys(props.clickableAreas)
          .sort(sortAlfabetCapitalized)
          .map((areaName) => {
            return (
              <ClickableAreaCard
                area={props.clickableAreas[areaName]}
                areaName={areaName}
                allClickableAreas={props.clickableAreas}
              />
            );
          })}
      </List>
    </Box>
  );
}

const sortAlfabetCapitalized = (a: string, b: string) => {
  const textA = a.toUpperCase();
  const textB = b.toUpperCase();

  return textA < textB ? -1 : textA > textB ? 1 : 0; // Neither key is in priority list sort by alfabet
};
